import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const LIST_CONTENT_BLOCKER_SYMBOL = Symbol();
const useListContentBlocker = ()=>useImmutableContext(LIST_CONTENT_BLOCKER_SYMBOL);
const useListContentBlockerProvider = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return useImmutableContextProvider(LIST_CONTENT_BLOCKER_SYMBOL, ...args);
};
export { useListContentBlocker, useListContentBlockerProvider };
